<template>
  <div id="app">
    <keep-alive exclude="topbar">
      <router-view v-if="keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!keepAlive"></router-view>
  </div>
</template>

<script>
export default{
  name: 'App',
  data() {
    return {
    }
  },
  computed:{
    keepAlive(){
      return this.$route.meta.keepAlive
    }
  }
}
</script>

<style>
  /*禁止元素选中*/
-moz-user-select: none; /*火狐*/
-webkit-user-select: none; /*webkit浏览器*/
-ms-user-select: none; /*IE10*/
-khtml-user-select: none; /*早期浏览器*/
user-select: none;
</style>

<style lang="scss">
.page-container {
  background-color: #FFFFFF;
  border-radius: 16px;
  padding: 30px;
}
</style>
